import { BUTTON_DEFAULT } from "../../../framework/bar-button/BarButtonFw";
import GridFw, { COLUMN_DEFAULT } from "../../../framework/grid/GridFw";
import { BasePage } from "../../../framework/pages/BasePage";
import { MessageUtil } from "../../../util/MessageUtil";

export class AnalisisMuestraModal extends BasePage {
  createPageProperties = (pageApi) => {
    return {
      title: "Busqueda de Analisis",
      barHeader: {
        fields: [
          { ...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal() },
        ],
      },
    };
  };

  renderPage(pageApi) {
    const getGridAnalisis = () => pageApi?.getComponent("analisisGrid");
    let cantidad_puntos = 1;
    let frecuencia = 1;

    const formGridConfig = {
      //title: 'Analisis seleccionados',
      rowId: "codigo",
      showIndex: false,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      filter: true,
      //selection: {type: SELECTION_TYPE.MULTIPLE},
      load: {
        queryId: 597,
        params: {
          id_matriz: pageApi?.name?.mapFieldApi?.id_matriz?.value,
          id_doc_cotizacion: pageApi?.name?.values?.id_doc_cotizacion,
        },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "item", label: "Item" },
        { name: "nombre_matriz", label: "Matriz / DS" },
        { name: "analisis", label: "Parámetro" },
        { name: "acreditador", label: "Acreditado" },
        { name: "norma_referencia", label: "Norma Referencia" },
        { name: "laboratorio", label: "Laboratorio" },
        {
          type: "select",
          name: "parametros",
          maxVisible: 2,
          label: "Sub Parámetros",
          labelName: "parametrosDes",
          search: true,
          multipleInString: true,
          load: {
            queryId: 305,
            params: () => {
              return {
                id_rel_metodo_matriz:
                  getGridAnalisis()?.itemEditing?.id_rel_metodo_matriz,
              };
            },
          },
          multiple: true,
          editable: true,
          onChange: (value, row) => {
            //getGridAnalisis().getItemEditing().parametros = value;
            getGridAnalisis().refresh();
          },
        },
        {
          ...COLUMN_DEFAULT.ADD_SQUARE,
          color: "green",
          title: "Seleccionar",
          label: "Opciones",
          width: 100,
          onClick: async (value, row) => {
            await getGridAnalisis().saveItemEditing();
            getGridAnalisis().refresh();
            let analisis = row;

            if (analisis) {
              let sub_total = parseFloat(
                cantidad_puntos * frecuencia * analisis.precio_venta,
              ).toFixed(2);
              let obj_analisis = {
                ...analisis,
                cantidad_puntos,
                frecuencia,
                sub_total,
              };
              if (obj_analisis.parametros == "") {
                if (analisis.compuesto == 0) {
                  return MessageUtil(
                    "warning",
                    "Alerta!",
                    "Debe seleccionar por lo menos un Sub parámetro para el Análisis!",
                  );
                }
              }
              pageApi.getEvent("afterAddEvent")(obj_analisis);
            } else {
              return MessageUtil(
                "warning",
                "Alerta!",
                "Debe seleccionar por lo menos un parámetro",
              );
            }
          },
        },
      ],
    };

    return (
      <>
        <GridFw
          name="analisisGrid"
          getParentApi={pageApi.getApi}
          config={formGridConfig}
        />
      </>
    );
  }
}
